import { memo } from "react";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { VariableTextChip } from "@components/forms/VariableTextField/VariableTextChip";
import {
    resetValueToText,
    type ResetValuePart,
} from "@components/settings/ReportSettings/reportSettingsSourceCopy";
import styles from "./ReportSettingsActivityCells.module.scss";

interface ReportSettingsActivityTextCellProps {
    getValue: () => string | ResetValuePart[] | null | undefined;
}

export const ReportSettingsActivityTextCell = memo(
    ({ getValue }: ReportSettingsActivityTextCellProps) => {
        const value = getValue();
        if (Array.isArray(value)) {
            return (
                <ViewTableCell>
                    <Tooltip content={resetValueToText(value)}>
                        <span className={styles.variableValue}>
                            {value.map((part, index) =>
                                part.kind === "variable" ? (
                                    <VariableTextChip
                                        key={index}
                                        label={part.label}
                                        className={styles.readOnlyVariable}
                                    />
                                ) : (
                                    <span key={index}>{part.text}</span>
                                ),
                            )}
                        </span>
                    </Tooltip>
                </ViewTableCell>
            );
        }
        return (
            <ViewTableCell>
                {value ? (
                    <BreakableText text={value} showTooltip />
                ) : (
                    <EmptyValue />
                )}
            </ViewTableCell>
        );
    },
);

ReportSettingsActivityTextCell.displayName = "ReportSettingsActivityTextCell";
